import auth from "../../middlewares/auth";
export const settingsConnectionServicesRoute = [
  {
    path: '/settings/connection/service',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/connection_service/ConnectionServiceList'),
    name: 'settings_connection_services',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/connection/service/add',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/connection_service/ConnectionServiceForm'),
    name: 'settings_connection_service_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/connection/service/edit/:id',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/connection_service/ConnectionServiceForm'),
    name: 'settings_connection_service_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];